import HydrantMapItemModelBase from '../_generated/modelBases/hydrant-map-item-model-base';

export default class HydrantMapItemModel extends HydrantMapItemModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
